import mandatoryLogin from "./mandatoryLogin"
export default mandatoryLogin;
